// extracted by mini-css-extract-plugin
export default {"btop":"_912dce189a _61ee229f6b _2c539eedea","icon":"_0cc2cb5092 dfd234f1d1","btoppink":"d2331c73ad ccea02e185"};